import Adress from "../../components/Adress";

const Imprint = () => {
  return (
    <div className="pt-24 md:w-160 m-0 m-auto px-9">
      <h1 className="text-3xl mb-20 font-Atma">
        Impressum Erlebniswelt Bauernhof
      </h1>
      <div className="mb-16">
        <Adress />
      </div>

      <div className="">
        <h2 className="text-2xl mb-4 font-bold">Haftungshinweis</h2>
        <p className="mb-16">
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
          sind ausschliesslich deren Betreiber verantwortlich. Der Missbrauch
          dieser gesetzlich vorgeschriebener Angaben wird als unzulässiger
          Eingriff in den geschäftlichen Betrieb (§ 823 Abs 1 BGB) geahndet. Es
          gilt deutsches Recht. Soweit Anbieter externer Websites in der
          Verwendung von Informationen auf dieser Website Urheber- und/oder
          Wettbewerbsrechtsverstösse sehen, bitten wir um einen kurzen Hinweis.
          Wir werden entsprechende Verstösse, wenn sie tatsächlich vorliegen,
          unverzüglich beseitigen, ohne dass es einer Abmahnung bedarf. Die
          Beseitigung einer möglicherweise von dieser Homepage ausgehenden
          Schutzrecht-Verletzung durch Schutzrecht-Inhaber selbst, hat nicht
          ohne unsere Zustimmung stattzufinden.
        </p>
        <h2 className="text-2xl mb-10 font-bold">Haftungsausschluss</h2>
        <h3 className="text-xl mb-4">1. Inhalt des Onlineangebotes</h3>
        <p className="mb-10">
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit,
          Vollständigkeit oder Qualität der bereitgestellten Informationen.
          Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller
          oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung
          der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und
          unvollständiger Informationen verursacht wurden, sind grundsätzlich
          ausgeschlossen, sofern seitens des Autors kein nachweislich
          vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle
          Angebote sind freibleibend und unverbindlich. Der Autor behält es sich
          ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
          gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die
          Veröffentlichung zeitweise oder endgültig einzustellen.
        </p>
        <h3 className="text-xl mb-4">2. Verweise und Links</h3>
        <p className="mb-10">
          Bei direkten oder indirekten Verweisen auf fremde Internetseiten
          ("Links"), die außerhalb des Verantwortungsbereiches des Autors
          liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in
          Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es
          ihm technisch möglich und zumutbar wäre, die Nutzung im Falle
          rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit
          ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen
          Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die
          aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft
          der gelinkten/verknüpften Seiten hat der Autor keinerlei Einfluss.
          Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten
          aller gelinkten /verknüpften Seiten, die nach der Linksetzung
          verändert wurden. Diese Feststellung gilt für alle innerhalb des
          eigenen Internetangebotes gesetzten Links und Verweise sowie für
          Fremdeinträge in vom Autor eingerichteten Gästebüchern,
          Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder
          unvollständige Inhalte und insbesondere für Schäden, die aus der
          Nutzung oder Nichtnutzung solcherart dargebotener Informationen
          entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen
          wurde, nicht derjenige, der über Links auf die jeweilige
          Veröffentlichung lediglich verweist.
        </p>
        <h3 className="text-xl mb-4">3. Urheber- und Kennzeichenrecht</h3>
        <p className="mb-10">
          Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der
          verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu
          beachten, von ihm selbst erstellte Grafiken, Tondokumente,
          Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken,
          Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb
          des Internetangebotes genannten und ggf. durch Dritte geschützten
          Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen
          des jeweils gültigen Kennzeichenrechts und den Besitzrechten der
          jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen
          Nennung ist nicht der Schluß zu ziehen, dass Markenzeichen nicht durch
          Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom
          Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten.
          Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente,
          Videosequenzen und Texte in anderen elektronischen oder gedruckten
          Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht
          gestattet.
        </p>

        <h3 className="text-xl mb-4">
          4. Rechtswirksamkeit dieses Haftungsausschlusses
        </h3>
        <p className="mb-10">
          Dieser Haftungsausschluss ist als Teil des Internetangebotes zu
          betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile
          oder einzelne Formulierungen dieses Textes der geltenden Rechtslage
          nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben
          die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit
          davon unberührt.
        </p>
        
      </div>
    </div>
  );
};

export default Imprint;
